import { useEffect, useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'

import { periodFromSearch, periodToSearch } from '../Helpers/reportPeriod'

import type { IReportPeriod } from '../Contracts/IReportPeriod'

/**
 * Період звіту з адреси (`SPEC-027` §3.4): `?from=&to=` — джерело правди,
 * тож посилання відкриває той самий період, а «Назад» у браузері повертає
 * попередній.
 *
 * Без параметрів звіт відкривається за поточний місяць (Q3.5), і цей місяць
 * одразу дописується в адресу (`replace`, без зайвого кроку історії) —
 * скопійоване посилання вже несе явний період, а не «поточний місяць» того,
 * хто його відкриє.
 */
export const useReportPeriod = (): [IReportPeriod, (period: IReportPeriod) => void] => {
    const [params, setParams] = useSearchParams()
    const query = params.toString()
    const period = useMemo(() => periodFromSearch(new URLSearchParams(query)), [query])

    useEffect(() => {
        const current = new URLSearchParams(query)
        const normalized = periodToSearch(period, current)

        if (normalized.toString() !== current.toString()) setParams(normalized, { replace: true })
    }, [query, period, setParams])

    const change = (next: IReportPeriod) => setParams(periodToSearch(next, new URLSearchParams(query)))

    return [period, change]
}
